import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { StepperModule } from 'primeng/stepper';

import { StepperStepInterface } from '../../../types/interfaces/stepper.interface';

@Component({
  selector: 'app-stepper-component',
  imports: [
    StepperModule,
    TranslatePipe,
  ],
  templateUrl: './stepper-component.html',
  styleUrl: './stepper-component.css',
})
export class StepperComponent {
  @Input()
  public activeStep: number = 1;

  @Input()
  public steps: StepperStepInterface[] = [];

  @Output()
  public onStepClickEvent: EventEmitter<number> = new EventEmitter<number>();

  public onStepClick(value: number): void {
    this.onStepClickEvent.emit(value);
  }

  public isStepActive(stepValue: number): boolean {
    return stepValue <= this.activeStep;
  }
}